<template>
  <div class="stat-section" v-if="showStat">
    <ion-list class="mt-20 mb-2 ladder-wrapper" lines="none">
      <ion-item class="header-row">
        <ion-label class="place rank-col">
          <ion-text >
            <span class="stats-header ">
              Rank
            </span>
          </ion-text>
        </ion-label>
        <ion-label class="ion-text-wrap player-name">
          <ion-text>
            <span class="stats-header">
              Name
            </span>
          </ion-text>
        </ion-label>
        <ion-label class="ion-text-wrap team-name">
          <ion-text>
            <span class="stats-header">
              Team
            </span>
          </ion-text>
        </ion-label>
        <ion-label class="stats-header stat-col">
          <ion-text>
            <span class="stats-header">
              Played
            </span>
          </ion-text>
        </ion-label>
        <ion-label class="stats-header stat-col">
          <ion-text>
            <span class="stats-header">
              {{ get(eventType, 'name', '') }}
            </span>
          </ion-text>
        </ion-label>
        <!-- <ion-label class="stats-header stat-col">
          <ion-text>
            <span class="stats-header">
              PVTotal
            </span>
          </ion-text>
        </ion-label> -->
      </ion-item>
      <div class="team-wrapper" v-for="(player, index) in eventLadder" :key="player._id" @click="goPlayer(player._id)">
        <ion-item v-if="player.eventSum > 0">
          <ion-label class="place rank-col">
          <ion-text>
            <span class="stats">
              {{ index + 1 }}.
              <!-- <svg width="5" height="4" viewBox="0 0 5 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="2.5" cy="2" r="2" fill="#B6B6B6"/>
              </svg> -->
            </span>
          </ion-text>
        </ion-label>
          <ion-label class="ion-text-wrap player-name">
            <ion-text>
              <span class="stats" style="font-weight:600">
                {{ `${player.firstName} ${player.lastName}` }}
              </span>
            </ion-text>
          </ion-label>
          <ion-label class="ion-text-wrap team-name">
            <ion-text>
              <span class="stats">
                <img class="club-logo" :src="get(player, 'teamImg.imgUrl', clubPlaceholder)"
                />
                <span class="team-name-text">
                  {{ `${player.team.name}` }}
                </span>
              </span>
            </ion-text>
          </ion-label>
          <ion-label class="stats justify-center stat-col">
            <ion-text>
              <span class="stats ">
                {{ player.matchPlayed }}
              </span>
            </ion-text>
          </ion-label>
          <ion-label class="stats justify-center stat-col">
            <ion-text>
              <span class="stats stats-pts">
                {{ player.eventSum }}
              </span>
            </ion-text>
          </ion-label>
          <!-- <ion-label class="stats justify-center stat-col">
            <ion-text>
              <span class="stats stats-pts">
                {{ player.potmValueTotal }}
              </span>
            </ion-text>
          </ion-label> -->
        </ion-item>
      </div>
    </ion-list>
  </div>
  <div class="option-row d-flex justify-center mt-20" v-else>
    <p class="c-white">
      No stats so far this season
    </p>
  </div>
</template>

<script>
export default {
  name: 'ScoringLadderView',
  props: {
    eventLadder: {
      type: Array,
      required: true,
      default: () => [],
    },
    eventType:{
      type:Object,
      required:true
    }
  },
  data() {
    return {
      key: 0,
      get: _.get,
    }
  },
  methods: {
    goPlayer(playerId) {
      this.$router.push(`/players/${playerId}`);
    },
  },
  computed: {
    clubPlaceholder() {
      return process.env.VUE_APP_PLACEHOLDER;
    },
    teamsByPool() {
      const { teams } = this.ladder;
      return teams
        ? teams.reduce((result, item) => {
          const value = item.pool;
          // eslint-disable-next-line no-param-reassign
          result[value] = (result[value] || []).concat(item);
          return result;
        }, {}) : false;
    },
    showStat() {
      return this.eventLadder.length && this.eventLadder.some(p => p.eventSum > 0);
    }
  }
};
</script>

<style scoped lang="scss">

/* Assemble Sports Fonts */
@font-face {
	font-family: 'BrownStd-Bold';
	src: url('../assets/fonts/BrownStd-Bold.otf') format('truetype'); /* IE9 Compat Modes */
}
@font-face {
	font-family: 'BrownStd-Regular';
	src: url('../assets/fonts/BrownStd-Regular.otf') format('truetype'); /* IE9 Compat Modes */
}
@font-face {
	font-family: 'BrownStd-Light';
	src: url('../assets/fonts/BrownStd-Light.otf') format('truetype'); /* IE9 Compat Modes */
}

.fade-enter-active,
.fade-leave-active {
  transition: all .5s;
}

.fade-enter,
.fade-leave-to
/* .fade-leave-active below version 2.1.8 */

{
  opacity: 0;
  height: 0;
}

.team-name {
  min-width: 10rem;
  @media only screen and(min-width: 350px) {
    min-width: 3rem;
    .team-name-text {
      display:none;
    }
  }
}

.player-name {
  min-width: 10rem;
  @media only screen and(min-width: 350px) {
    min-width: 7rem;
  }
}
.stat-col {
  min-width: 3rem;
  max-width: 3rem;
}
.rank-col {
  min-width: 3rem;
  max-width: 3rem;
  @media only screen and(min-width: 350px) {
    min-width: 2.5rem;
  }
}

.ladder-wrapper {
  border-radius: 1rem;
  margin-left: 1rem;
  margin-right: 1rem;
  padding-bottom: 1.5rem;
  /* box-shadow:
  0 0.4px 0.4px rgba(0, 0, 0, 0.016),
  0 1px 1px rgba(0, 0, 0, 0.022),
  0 2.1px 2.1px rgba(0, 0, 0, 0.028),
  0 4.4px 4.4px rgba(0, 0, 0, 0.034),
  0 12px 12px rgba(0, 0, 0, 0.05)
; */
  -webkit-box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
  box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
}

.stats {
  font-family: 'BrownStd-Regular';
  display:flex;
  font-style: normal;
  font-weight: normal;
  font-size: 0.7rem;
  line-height: 1rem;
  /* identical to box height, or 123% */

  text-align: center;

  color: white;
  .club-logo{
    width: 1.25rem;
  height: 1.25rem;
  border: 2px solid rgba(226, 9, 9, 0.1);
  border-radius: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  transition: all 0.1s ease-in-out;
  margin-right:0.5rem;
  }
  text-overflow: clip;
}

.option-row {
  --offset-bottom: auto!important;
  --overflow: hidden;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  background: $background !important;
}

.stats-pts {
  font-family: 'BrownStd-Bold';
  font-weight: bold;
}

.pool-name {
  font-family: "BrownStd-Regular";
  font-style: normal;
  font-weight: bold;
  font-size: 1.2rem;
  line-height: 137.4%;
  letter-spacing: 0.02em;
  color: white;
}

.stats-header {
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: bold;
  font-size: .8rem;
  line-height: 1rem;
  /* identical to box height, or 114% */

  text-align: center;

  color: white;
  text-overflow: clip;
}

.active {
  background: $highlight;
}

ion-list, ion-item {
  background: transparent;
  --background: transparent;
}



</style>
